import { inject, NewInstance } from 'aurelia-framework';
import { AssignedProjectService } from 'pages/daiatari/assigned-projects/service';
import { StatusService } from 'pages/system-fields/statuses/service';
import { PlantService } from 'pages/quote-setup/plants/service';
import { ProjectService } from 'pages/quote-setup/projects/service';
import { CustomerService } from 'pages/quote-setup/customers/service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { DialogController } from 'aurelia-dialog';
import { DialogService } from 'aurelia-dialog';
import { ValidationRules, ValidationController, validateTrigger } from 'aurelia-validation';
import { BootstrapFormRenderer } from 'resources/validation-renderer';
import toastr from 'toastr';

@inject(DialogController, NewInstance.of(ValidationController), AssignedProjectService, StatusService, PlantService, ProjectService, CustomerService, EventAggregator, DialogService)
export class StatusEditor {
    constructor(controller, validationController, assignedProjectService, statusService, plantService, projectService, customerService, ea, dialogService) {
        this.controller = controller;
        this.assignedProjectService = assignedProjectService;
        this.statusService = statusService;
        this.plantService = plantService;
        this.projectService = projectService;
        this.customerService = customerService;
        this.dialogService = dialogService;
        this.ea = ea;
        this.assignedProject = {};

        this.validationController = validationController;
        this.validationController.validateTrigger = validateTrigger.manual;
        this.validationController.addRenderer(new BootstrapFormRenderer());
        this.rules = ValidationRules
            .ensure('description').required()
            .ensure('statusId').required()
            .rules;
    }

    async activate(model) {
        if (model?.id != null) {
            this.assignedProject = await this.assignedProjectService.getById(model.id);
        }
    }

    addPlant() {
        this.dialogService.open({ viewModel: this.plantService.editor });
    }

    addStatus () {
        this.dialogService.open({ viewModel: this.statusService.editor });
    }

    addProject() {
        this.dialogService.open({ viewModel: this.projectService.editor });
    }

    addCustomer() {
        this.dialogService.open({ viewModel: this.customerService.editor });
    }

    async save() {
        if (this.isRequesting) return;
        this.isRequesting = true;
        const validationResult = await this.validationController.validate();
        if (validationResult.valid) {
            try {
                if (this.assignedProject.id) {
                    await this.assignedProjectService.update(this.assignedProject);
                    toastr.success('Assigned project was updated!');
                } else {
                    await this.assignedProjectService.create(this.assignedProject);
                    toastr.success('New assigned project was created!');
                }
                this.ea.publish('assigned-projects:updated', this.assignedProject);
                this.controller.ok(this.assignedProject);
            } catch {
                this.isRequesting = false;
            }
        }
        this.isRequesting = false;
    }
}